<template>
  <div class="userCenterCon historyTrain">
    <mt-header fixed title="">
      <div slot="left">
        <!-- <span @click="goBack" class="backSpan"><img src="../assets/imgs/backIcon.png" alt=""></!-->
        <mt-button router-link="'/'">历史培训计划</mt-button>
      </div>
      <!-- <div slot="right" @click="selectData">{{selectedValue}}<i class="mint-cell-allow-bottom"></i></div> -->
      <div slot="right" @click="selectData">
        <input class="text-hui" v-model="selectedValue"  readonly/>
        <i class="mint-cell-allow-bottom"></i>
      </div>
    </mt-header>
    <!-- <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="5"> -->
    <div v-for="(item,index) in list" :key="index" v-show="!isHasdata">
      <router-link :to="{name:'programDetail',query:{eid:eId,pid:item.id,cid:cId,year:selectedValue,sMonth:item.study_month,fromW:'list'}}">
      <div class="item">
          <div class="itemTit">
            <i>{{index+1}}</i>{{item.study_plan_name}}
            <mt-badge type="error" size="small" v-if="item.study_type==0">必</mt-badge>
          </div>
          <i class="mint-cell-allow-right"></i>
      </div>
      </router-link>
    </div>
    <div v-show="isHasdata" class="noData">
      <img src="../assets/imgs/noDate.png" alt="">
      <p>暂无数据</p>
    </div>
    <!-- </div> -->
     <!-- 学习时间---start -->
    <mt-popup v-model="ispopupVisible" popup-transition="popup-fade" closeOnClickModal="true" position="bottom">
      <mt-picker :slots="slotDatas" @change="onValuesChange" style="width: 7.5rem;" showToolbar>
        <div class="picker-toolbar-title">
        <div class="usi-btn-cancel" @click="ispopupVisible = !ispopupVisible">取消</div>
        <div class="">请选择学习年份</div>
        <div class="usi-btn-sure" @click="onPickerOK">确定</div>
        </div>
      </mt-picker>
    </mt-popup>
     <!-- 学习时间---end -->
  </div>
</template>

<script>
import { studyYearPlan, studyYears } from '../../src/api/Api'
export default {
  name: 'userinfos',
  data () {
    return {
      list: [
        // {id: 1, info: '内容内容内容1', isMust: false},
        // {id: 2, info: '内容内容内容2', isMust: false},
        // {id: 3, info: '内容内容内容3', isMust: true},
        // {id: 4, info: '内容内容内容1', isMust: false},
        // {id: 5, info: '内容内容内容2', isMust: false},
        // {id: 6, info: '内容内容内容3', isMust: true},
        // {id: 7, info: '内容内容内容1', isMust: false},
        // {id: 8, info: '内容内容内容2', isMust: false},
        // {id: 9, info: '内容内容内容3', isMust: true},
        // {id: 10, info: '内容内容内容1', isMust: false},
        // {id: 11, info: '内容内容内容2', isMust: false},
        // {id: 12, info: '内容内容内容3', isMust: true}
      ],
      loading: false,
      showToolbar: true,
      dateVal: '',
      selectedValue: 2019,
      endDate: new Date(),
      isHasdata: false,
      // slots: [{
      //   values: ['2019', '2018', '2017', '2016']
      // }],
      slotsData: [],
      ispopupVisible: false,
      pickCheckedVal: '',
      eId: sessionStorage.getItem('userId'),
      cId: sessionStorage.getItem('companyId')
    }
  },
  created () {
    this.GetstudyYears()
    this.GetstudyYearPlan()
  },
  computed: {
    slotDatas () {
      let allData = [
        {
          values: this.slotsData
        }
      ]
      return allData
    }
  },

  methods: {
    goBack: function () {
      history.back()
    },
    GetstudyYearPlan: function () {
      var _this = this
      studyYearPlan({
        'employeeId': Number(_this.$route.query.eid),
        'studyYear': _this.selectedValue
      }).then(res => {
        if (res.data.code === 200) {
          _this.isHasdata = false
          _this.list = res.data.data
        } else {
          _this.isHasdata = true
        }
      })
    },
    GetstudyYears: function () {
      var _this = this
      studyYears({
        'employeeId': Number(_this.$route.query.eid)
      }).then(res => {
        if (res.data.code === 200) {
          res.data.data.forEach(function (c) {
            _this.slotsData.push(c.study_year)
          })
        } else {
          _this.isHasdata = true
        }
      })
    },
    loadMore () {
      this.loading = true
      setTimeout(() => {
        let last = this.list[this.list.length - 1]
        for (let i = 1; i <= 5; i++) {
          this.list.push(last + i)
        }
        this.loading = false
      }, 500)
    },
    selectData () {
      this.ispopupVisible = true
    },
    onValuesChange (picker, values) {
      this.pickCheckedVal = values[0]
      this.selectedValue = this.$moment(new Date()).format('YYYY')
    },
    onPickerOK () {
      this.ispopupVisible = !this.ispopupVisible
      this.selectedValue = this.pickCheckedVal
      this.GetstudyYearPlan()
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/views/HistoryTrainProgram.vue